const NAV_ORDERS = 'Orders_1';
const NAV_CONFIGURATION = 'Configuration_4';
const URL_ORDER = '/order';
const URL_MANAGE_CUSTOMER_USERS = '/manage-customer-users';
const URL_MANAGE_INTERNAL_USERS = '/manage-internal-users';
const URL_PATIENT_LIST = '/patient-list';
const URL_ANNOUNCEMENTS = '/announcements';
const LABEL_CONFIGURATION = 'Configuration';
const LABEL_ORDERS = 'Orders';
const LABEL_PATIENTS = 'Patients';

export enum PermissionsEnum {
  CanManageOtherInternalUsers = 'CanManageOtherInternalUsers',
  CanManageCustomerUsers = 'CanManageCustomerUsers',
  CanManageOtherUsers = 'CanManageOtherUsers',
  CanViewPatientResultForLA = 'CanViewPatientResultForLA',
  CanPlaceOrders = 'CanPlaceOrders',
  CanManageProjects = 'CanManageProjects',
  CanViewPurchaseOrders = 'CanViewPurchaseOrders',
  CanManageLabConfiguration = 'CanManageLabConfiguration',
  CanManagePatients = 'CanManagePatients',
  CanInputPOCResults = 'CanInputPOCResults',
  CanApproveOrders = 'CanApproveOrders',
  CanManageAccounts = 'CanManageAccounts',
  CanManagePackages = 'CanManagePackages',
  CanRegisterLabels = 'CanManagePackages',
  CanCreateBulkOrder = 'CanCreateBulkOrder',
  CanBulkUploadPatients = 'CanBulkUploadPatients',
  CanViewAuditLogs = 'CanViewAuditLogs'
}

export const navDisplayText = {
  subTabOrders: NAV_ORDERS,
  subTabPurchaseOrder: NAV_ORDERS,
  subTabManagePackages: NAV_ORDERS,
  subTabResult: 'Results_2',
  subTabManagePatients: 'Patients_3',
  subTabManageProjects: NAV_CONFIGURATION,
  subTabManageUser: NAV_CONFIGURATION,
  subTabAnnouncements: NAV_CONFIGURATION,
  subTabManageLabConfiguration: NAV_CONFIGURATION,
  subTabManageAccounts: NAV_CONFIGURATION,
  SubTabRegisterLabels: NAV_CONFIGURATION,
  subTabViewAuditLogs: NAV_CONFIGURATION,
} as const;

export const routerURLS = {
  subTabOrders: URL_ORDER,
  subTabPurchaseOrder: '',
  subTabResult: '/results',
  subTabManagePatients: URL_PATIENT_LIST,
  subTabManageProjects: '',
  subTabManageUser: '',
  subTabAnnouncements: '',
  subTabManageLabConfiguration: '',
  subTabManageAccounts: '',
  subTabManagePackages: '',
  subTabViewAuditLogs: '',
} as const;

export const RoutesPermissionsEnum = {
  CanManageOtherInternalUsers: URL_MANAGE_INTERNAL_USERS,
  CanManageCustomerUsers: URL_MANAGE_CUSTOMER_USERS,
  CanManageOtherUsers: URL_MANAGE_CUSTOMER_USERS,
  CanManageLabConfiguration: 'Lab Configuration',
  CanManagePatients: URL_PATIENT_LIST,
  CanPlaceOrders: URL_ORDER,
  CanInputPOCResults: '/order/input-point-of-care',
  CanApproveOrders: '/order/pending-approvals',
  CanViewPurchaseOrders: '/order/purchase-order',
  CanManageProjects: '/manage-projects',
  CanAnnouncement: URL_ANNOUNCEMENTS,
  CanManageAccounts: '/manage-accounts',
  CanManagePackages: '/order/manage-packages',
  CanCreateBulkOrder: '/order/create-bulk-order',
  CanRegisterLabels: '/register-labels',
  CanViewPatientResultForLA: '/order/order-tracker',
  CanViewAuditLogs: '/user-activity-log',
} as const;

export const submenuURL = {
  '/manage-internal-users,/manage-customer-users': 'Users',
  [URL_MANAGE_CUSTOMER_USERS]: 'Customer Users',
  [URL_MANAGE_INTERNAL_USERS]: 'Internal Users',
  '/order/create-order': 'Place New Order',
  [URL_ORDER]: 'View Orders',
  '/order?viewType=standing': 'View Standing Orders',
  '/order/input-point-of-care': 'Input Point Of Care',
  '/order/pending-approvals': 'Pending Approvals',
  '/order/purchase-order': 'Purchase Orders',
  '/manage-projects': 'Projects',
  [URL_ANNOUNCEMENTS]: 'Announcements',
  'Lab Configuration': 'Lab Configuration',
  [URL_PATIENT_LIST]: LABEL_PATIENTS,
  '/manage-accounts': 'Accounts',
  '/order/manage-packages': 'Manage Packages',
  '/register-labels': 'Register Labels',
  '/order/order-tracker': 'Order Tracker',
  '/order/create-bulk-order': 'Bulk Upload Orders',
  '/user-activity-log': 'User Activity Log',
} as const;

export const ChildMappedURL = {
  // '/specimen-type': LABEL_CONFIGURATION,
  '/questions': LABEL_CONFIGURATION,
  '/tests': LABEL_CONFIGURATION,
  '/test-panels': LABEL_CONFIGURATION,
  '/user-activity-log': LABEL_CONFIGURATION,
  [URL_MANAGE_CUSTOMER_USERS]: LABEL_CONFIGURATION,
  [URL_MANAGE_INTERNAL_USERS]: LABEL_CONFIGURATION,
  ' /manage-projects': LABEL_CONFIGURATION,
  ' /manage-accounts': LABEL_CONFIGURATION,
  [URL_ANNOUNCEMENTS]: LABEL_CONFIGURATION,
  '/payors': LABEL_CONFIGURATION,
  [URL_PATIENT_LIST]: LABEL_PATIENTS,
  '/bulk-upload': LABEL_PATIENTS,
  [URL_ORDER]: LABEL_ORDERS,
  '/order/create-order': LABEL_ORDERS,
  '/order?viewType=standing': LABEL_ORDERS,
  '/order/input-point-of-care': LABEL_ORDERS,
  '/order/purchase-order': LABEL_ORDERS,
  '/order/pending-approvals': LABEL_ORDERS,
  '/order/manage-packages': LABEL_ORDERS,
  '/order/order-tracker': LABEL_ORDERS,
  '/register-labels': LABEL_CONFIGURATION,
} as const;

export const hasPrefix = {
  '/order/confirm-order': LABEL_ORDERS,
} as const;
